module.exports = __webpack_public_path__ + "static/builder-four@2x-03f3ccc9e4ac78df68b2b19a11dd7af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/android-app-builder/builder-four@2x.png
// module id = 2534
// module chunks = 168707334958949